// extracted by mini-css-extract-plugin
export default {"autoSelect":"multiSelect_autoSelect__1KDAj"};